<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <button class="btn btn-back btn-outline-secondary" @click="goBack">
          Back
        </button>
      </div>
    </div>
    <div class="row">
      <file-event-list-header />
    </div>
    <div class="row">
      <vue-good-table
        class="vue-table"
        ref="table"
        mode="remote"
        :isLoading.sync="isLoading"
        :totalRows="typesenseStore.totalRecords"
        :rows="typesenseStore.eventList"
        :columns="columns"
      >
      </vue-good-table>
    </div>
  </div>
</template>

<script setup lang="ts">
import FileEventListHeader from "@/components/Search/FileEventListHeader.vue";
import { useTypesenseStore } from "@/stores/typesense";
import { useAsyncState } from "@vueuse/core";
import moment from "moment";
import { ref, watch } from "vue";
import { useRouter } from "vue-router";

const typesenseStore = useTypesenseStore();
const isLoading = ref(false);

watch(
  () => typesenseStore.loading,
  (updateLoading) => (isLoading.value = updateLoading)
);

const formatFn = (value) => {
  return moment.unix(value).format("DD MMM yyyy HH:mm:ss");
};

const columns = [
  {
    label: "Event Name",
    field: "name",
    sortable: false,
  },
  {
    label: "Event UUID",
    field: "uuid",
    sortable: false,
  },
  {
    label: "Date",
    field: "date",
    formatFn: formatFn,
    sortable: false,
  },

  {
    label: "Software Used",
    field: function (rowObj) {
      return rowObj.software_used ? rowObj.software_used : "-";
    },
    sortable: false,
  },
  {
    label: "Outcome",
    field: "outcome",
    sortable: false,
  },
  {
    label: "Outcome Note",
    field: function (rowObj) {
      return rowObj.outcome_note ? rowObj.outcome_note : "-";
    },
    sortable: false,
  },
];

const router = useRouter();

const goBack = () => {
  typesenseStore.currentFile = [];
  router.push({ name: "aipdipdetails" });
};

var current_file = router.currentRoute.value.params.selectedFileId.toString();

const serverParamsEvent = ref({
  filter_by: "file_uuid:" + current_file,
  sort_by: "",
  q: "*",
  query_by: "file_uuid",
  per_page: 50,
});

const serverParamsFile = ref({
  filter_by: "uuid:" + current_file,
  sort_by: "",
  q: "*",
  query_by: "uuid",
  per_page: 50,
});

const { execute } = useAsyncState(() => {
  return (
    typesenseStore.fetchTypesenseEvent(serverParamsEvent.value),
    typesenseStore.fetchTypesenseFile(serverParamsFile.value)
  );
}, null);
</script>

<style scoped>
.container-fluid {
  padding: 16px;
}
.btn-back {
  position: relative;
  float: left;
  width: 120px;
}
.vue-table {
  padding: 10px;
}
</style>
